export default __webpack_public_path__ + "static/Vol 3 - TA 1B - GIS-664354ec8a0ee740a8c352c37462f470.pdf";